<template>
  <div
    :id="`Qna1-${pageUid}`"
    :class="`c-${answerColor} bg-${backgroundColor}`"
    class="qna qna1 qna--1 lp-section qna-container width-expand">
    <div class="container container-l padding-max-vertical">
      <h2 class="text-max c-alt text-center" :class="`c-${titleColor}`">
        <span>{{ title }}</span>
      </h2>
      <div class="qna-external-wrapper container width-expand">
        <div
          class="qna-wrapper width-expand padding-xl radius-m"
          :class="`bg-${questionWrapperColor}`">
          <div class="qna-container flex flex-wrap l:flex-no-wrap l:gap-xl">
            <div
              class="question-column width-expand"
              :class="`question-column--${questionColumnIndex}`"
              v-for="(questionGroup, questionColumnIndex) of splitQuestions">
              <div
                :class="
                  currentQuestionIndex === item.localIndex ? 'active' : ''
                "
                class="item"
                v-for="item in questionGroup">
                <div
                  class="question-title width-expand padding cursor-pointer"
                  @click="
                    track('qna1|questionTitle|click', {
                      value: item.question,
                    }).then(clickQuestionHandler(item.localIndex))
                  ">
                  <div class="flex flex-middle flex-between width-expand">
                    <h3
                      class="text-xl margin-remove"
                      :class="`c-${answerColor}`">
                      <span class="question-title-text">
                        {{ item.question }}
                      </span>
                    </h3>
                    <icon
                      class="question-title-icon"
                      style="transition: transform 100ms ease"
                      icon="chevron-inline-end"
                      :theme="iconColor"
                      size="2"></icon>
                  </div>
                </div>
                <div
                  class="question-answer animate__fadeIn animate--fast text-l"
                  v-show="currentQuestionIndex === item.localIndex">
                  <content-blocks
                    :content="item?.answer?.blocks"></content-blocks>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      questions: [
        {
          question: "",
          answer: {},
        },
      ],
      backgroundColor: "",
      questionWrapperColor: "",
      questionColor: "",
      answerColor: "",
      iconColor: "",
      titleColor: "",
      trackEvent: () => {},
      track: () => {},
      triggerSectionsEvent: () => {},
      pageUid,
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {
      currentQuestionIndex: -1,
    };
  },
  computed: {
    splitQuestions() {
      let result = [[], []];
      let questions = this.questions;
      let length = questions.length;
      let splitAt = Math.ceil(length / 2);
      let i = 0;

      questions.forEach((question) => {
        question.localIndex = i;
        if (i < splitAt) {
          result[0].push(question);
        } else {
          result[1].push(question);
        }
        i++;
      });

      return result;
    },
    listBulletColorCssProperty() {
      return `var(--c-${this.iconColor})`;
    },
  },
  methods: {
    clickQuestionHandler(index) {
      if (this.currentQuestionIndex === index) {
        this.currentQuestionIndex = -1;
      } else {
        this.currentQuestionIndex = index;
      }
    },
    async testMethod() {
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.qna1 {
  h2 {
    font-size: var(--font-max);
    font-weight: 600;
    line-height: 0.75;
    margin-bottom: var(--margin-2xl);
  }

  .question-column--0 {
    .item {
      @media (min-width:1024px) { // in first column only skip last separator in desktop (mobile is stacked)
        &:last-of-type {
          border-bottom: none;
        }
      }

    }
  }

  .question-column--1 {
    .item {
      &:last-of-type {
        border-bottom: none;
      }
    }
  }

  .item {
    border-bottom: 1px solid var(--c-gray);
    padding-block: var(--margin-m);

    .question-title {
      width: 100%;
      padding: var(--margin-m);
    }

    .question-answer {
      padding: var(--margin-m);
    }

    &.active {
      .question-title-text {
        font-weight: bold;
      }

      .question-title-icon {
        transform: rotate(-90deg);
      }
    }
  }

  :deep(.content-blocks) {
    h3 {
      font-weight: 600;
      font-size: var(--font-xl);
      margin-bottom: var(--margin-m);
    }

    h4 {
      font-weight: 400;
      font-size: var(--font-xl);
      margin-bottom: var(--margin-m);
    }

    h5 {
      font-weight: 600;
      font-size: var(--font-l);
      margin-bottom: var(--margin-s);
    }

    h6 {
      font-weight: 500;
      font-size: var(--font-l);
      margin-bottom: var(--margin-s);
    }

    li {
      font-size: var(--font-l);
    }

    ul li::marker {
      color: v-bind(listBulletColorCssProperty);
    }

    p {
      font-size: var(--font-l);
    }
  }
}
</style>
